<template>
  <div class="col-md-6 mt-5">
    <div class="row mb-2">
      <div class="col-md-6">
        <span class="dashboard-block_title">
          Top News
        </span>
      </div>
    </div>
    <div class="text-center mt-5" v-if="loading === true">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="dashboard-block" v-if="loading === false">
      <div class="text-center" v-if="news.length === 0">
        No News Found
      </div>
      <div class="row" v-if="news.length > 0">
        <div class="col-12 news" v-for="value in news" :key="value.length">
          <div class="row">
            <div class="col-1 p-0 text-center">
              <img src="@/assets/icons/icon-news.svg" alt="">
            </div>
            <div class="col-11 p-0">
              <a :href="value.link" target="_blank">
                {{ value.title }}
              </a>
              <div class="date-label text-left">
                {{ value.time }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopNews',
  props: {
    loading: Boolean,
    news: Array
  }
}
</script>

<style lang="scss" scoped>

.news {
  padding: 15px 10px;
  transition: all .3s;
  &:hover {
    background-color: rgba(0,0,0,.05);
    a {
      text-decoration: underline;
    }
  }
  a {
    color: rgba(0,0,0,1);
    font-size: 15px;
    letter-spacing: 0;
    line-height: 23px;
    text-decoration: none;
    transition: all .3s;
  }
  img {
    opacity: .7;
  }
}

.dashboard-block {
  max-height: 600px;
  min-height: 300px;
  overflow-y: auto;
  border: 1px solid rgba(231,232,232,1);
  border-radius: 12px;
  background-color: rgba(255,255,255,1);
  padding: 12px 0;

  &_title {
    color: rgba(0,0,0,1);
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 15px;
  }

  &_link {
    text-decoration: none;
    color: rgba(0,120,255,1);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 12px;
  }

  .task-for {
    color: rgba(0,0,0, .6);
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
    b {
      color: rgba(0,0,0,1);
      font-size: 14px;
      letter-spacing: 0;
      line-height: 21px;
    }
  }

  .task-title {
    opacity: 0.7;
    color: rgba(0,0,0,1);
    font-size: 15px;
    letter-spacing: 0;
    line-height: 23px;
    margin: 0;
  }

  .date-label {
    opacity: 0.4;
    color: rgba(0,0,0,1);
    font-size: 11px;
    letter-spacing: 0;
    line-height: 17px;
    text-align: right;
  }

  .row {
    width: 100%;
    margin: 0;
  }

  a {
    word-wrap: break-word;
  }
}

</style>
